/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import Component from 'can/component/component';
import template from './modal-description.stache';
import popupView from './popup.stache';
import DomEventsManager from 'scripts/dom-events-manager';
import can from 'can';

Component.extend({
    tag: 'modal-description',
    template: template,
    viewModel: {
        description: '',
        popupClassName: '',

        open: function(ev, element) {
            ev.preventDefault();

            let $body = can.$('body');
            let viewModel = this;

            if (viewModel.$popup) {
                viewModel.$popup.remove();
            }

            $body.append(
                popupView(
                    new can.Map({
                        description: this.description,
                        popupClassName: this.popupClassName,
                        destroy: () => {
                            if (viewModel.$popup) {
                                viewModel.$popup.remove();
                            }
                        },

                        inserted: function(el) {
                            viewModel.$popup = can.$(el);
                            viewModel.$popup.toggleClass('is-visible', true);
                            if (!viewModel.isMobile) {
                                let rect = element
                                    .querySelector('.s-modal-description__icon')
                                    .getBoundingClientRect();
                                let popupContent = viewModel.$popup.find(
                                    '.s-modal-description-popup__content',
                                );
                                popupContent.css({
                                    left:
                                        rect.left +
                                        rect.width * 2 -
                                        popupContent.width() / 2,
                                    top:
                                        rect.top +
                                        rect.height * 2 +
                                        popupContent.height() / 2,
                                });
                            }
                        },

                        close: function() {
                            this.destroy();
                        },
                    }),
                ),
            );
        },
    },
    events: {
        inserted: function($el) {
            DomEventsManager.subscribe(this);
            this.viewModel.$element = $el;
        },
        removed() {
            DomEventsManager.unsubscribe(this);
        },
        onWindowResize() {
            this.debouncedPosition(); //TODO refactor component to use only css positioning ASAP
        },
        debouncedPosition: _.debounce(function() {
            if (!this.viewModel.isMobile && this.viewModel.$popup) {
                let rect = this.element
                    .find('.s-modal-description__icon')
                    .get(0)
                    .getBoundingClientRect();
                let popupContent = this.viewModel.$popup.find(
                    '.s-modal-description-popup__content',
                );
                popupContent.css({
                    left: rect.left + rect.width * 2 - popupContent.width() / 2,
                    top: rect.top + rect.height * 2 + popupContent.height() / 2,
                });
            }
        }, 0),

        '{scope} isMobile'(element, event) {
            if (this.viewModel.$popup) {
                this.viewModel.$popup.remove();
            }
        },

        '{document} keyup'(element, event) {
            if (event.keyCode === 27 && this.viewModel.$popup) {
                this.viewModel.$popup.remove();
            }
        },
    },
});
